import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { WLWHero } from '../components/weight-loss-women/WLWHero';
export function WeightLossWomenPage() {
  return <div className="min-h-screen w-full bg-black font-body" style={{
    scrollBehavior: 'smooth'
  }} data-id="element-2681">
      <Navigation data-id="element-2682" />
      <main data-id="element-2683">
        <WLWHero data-id="element-2684" />
      </main>
      <Footer data-id="element-2685" />
    </div>;
}